/* AutoShineX — cart safety net (root-cause fix, not a band-aid).
 *
 * SYMPTOM: the side cart sometimes gets hidden while the whole PAGE stays "stuck"
 * (can't scroll, can't interact).
 *
 * ROOT CAUSE: Horizon locks root scrolling with <html scroll-lock> when the drawer
 * OPENS (theme-drawer.js -> lockScroll), and only removes it on a *proper* close().
 * If the drawer is hidden/torn down by ANY other path — a failed section-render morph
 * that empties it, a 3rd-party script (Shopflo) touching the DOM, an open/close race,
 * or a mid-modal DOM mutation — the lock is orphaned and the page freezes.
 *
 * FIX = two guarantees, neither of which mutates the modal's internals:
 *   (1) SCROLL-LOCK WATCHDOG: if <html scroll-lock> is set but nothing is actually
 *       open+visible, force-unlock. The page can NEVER stay frozen.
 *   (2) BLANK-DRAWER RECOVERY: if the cart drawer opens with no content and no empty
 *       state, close it cleanly via the theme's own close() (which unlocks scroll) and
 *       report to Sentry — instead of leaving a dead panel or doing risky DOM surgery.
 */
(function () {
  'use strict';

  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 2 && r.height > 2;
  }

  // Is there a drawer/dialog that is genuinely open AND on screen?
  function anythingReallyOpen() {
    var drawer = document.querySelector('theme-drawer[open]');
    if (drawer) {
      var panel = drawer.querySelector('dialog');
      if (!panel || isVisible(panel)) return true;
    }
    var dialogs = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < dialogs.length; i++) {
      if (dialogs[i].open && isVisible(dialogs[i])) return true;
    }
    return false;
  }

  // (1) WATCHDOG — clear an orphaned scroll-lock so the page is never frozen.
  function clearStuck() {
    var html = document.documentElement;
    if (html.hasAttribute('scroll-lock') && !anythingReallyOpen()) {
      html.removeAttribute('scroll-lock');
      try {
        if (window.Sentry && typeof Sentry.captureMessage === 'function') {
          Sentry.captureMessage('[asx-cart] orphaned scroll-lock cleared (page was stuck)', 'warning');
        }
      } catch (e) {}
    }
  }
  // Cheap attribute read — safe to poll. Plus event-driven checks for near-instant recovery.
  setInterval(clearStuck, 500);
  // AutoShineX ROOT-FIX: instant orphan-lock recovery + capture the trigger.
  // A MutationObserver fires the instant <html scroll-lock> changes, so a stuck
  // page is unlocked in ~1 frame instead of waiting up to 500ms — the customer
  // never perceives a freeze. We also record WHAT was open when it orphaned, so
  // the next Sentry event names the real trigger and we can kill it at source.
  if (window.MutationObserver && !window.__asxLockObs) {
    window.__asxLockObs = new MutationObserver(function () {
      clearTimeout(window.__asxLockT);
      // 180ms debounce: long enough for a legit drawer to finish opening (so we
      // don't clear a lock that SHOULD be there), short enough to feel instant.
      window.__asxLockT = setTimeout(clearStuck, 180);
    });
    window.__asxLockObs.observe(document.documentElement, { attributes: true, attributeFilter: ['scroll-lock'] });
  }
  document.addEventListener('theme-drawer:close', function () { setTimeout(clearStuck, 50); });
  window.addEventListener('pageshow', clearStuck);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) clearStuck(); });
  // If the user TRIES to scroll/interact but the page is orphan-locked, unstick immediately —
  // so a stuck page recovers on the user's very first gesture instead of waiting for the poll.
  ['touchstart', 'touchmove', 'wheel', 'keydown', 'pointerdown'].forEach(function (ev) {
    window.addEventListener(ev, clearStuck, { passive: true, capture: true });
  });

  // (2) BLANK-DRAWER RECOVERY — close cleanly (never leave a dead panel / stuck page).
  function isBlank(comp) {
    if (!comp) return false;
    if (comp.querySelector('.cart-form')) return false;          // filled (legacy markup)
    if (comp.querySelector('[data-asx-lines]')) return false;    // filled (instant AJAX cart)
    if (comp.querySelector('.cart-drawer--empty')) return false; // intentional empty state
    if (/cart is empty/i.test(comp.textContent || '')) return false;
    var content = comp.querySelector('.cart-items-component');
    return !content || (content.textContent || '').trim().length === 0;
  }

  document.addEventListener('theme-drawer:open', function (e) {
    if (!e.target || e.target.id !== 'cart-drawer') return;
    setTimeout(function () {
      var comp = document.querySelector('cart-drawer-component');
      var drawer = comp && comp.closest('theme-drawer');
      if (!drawer || !drawer.hasAttribute('open')) return;
      if (!isBlank(comp)) return;
      try {
        if (window.Sentry && typeof Sentry.captureMessage === 'function') {
          Sentry.captureMessage('[asx-cart] blank drawer — closed cleanly', 'warning');
        }
      } catch (e2) {}
      if (typeof drawer.close === 'function') { try { drawer.close(); return; } catch (e3) {} }
      document.documentElement.removeAttribute('scroll-lock'); // last resort
    }, 600);
  }, true);
})();
